import { useEffect, useState } from 'react';

import { MarketingHeader, MarketingFooter } from '../components/MarketingChrome';
import { RESOURCE_ARTICLES, RESOURCE_CATEGORIES } from '../components/ResourceSidebar';
import '../components/landing.css';
import './getting-started.css';

const PAGE_TITLE = 'Paddiq guides and resources | Paddiq';

export function ResourcesPage() {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('All resources');
  const articles = RESOURCE_ARTICLES.filter(
    (article) =>
      (category === 'All resources' || article.category === category) &&
      `${article.title} ${article.description}`.toLowerCase().includes(query.trim().toLowerCase()),
  );
  useEffect(() => {
    const previousTitle = document.title;
    document.title = PAGE_TITLE;

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="landing marketing-home mh-interior">
      <a className="mh-skip" href="#main">
        Skip to content
      </a>
      <MarketingHeader />

      <main id="main">
        <section className="guide-hero resource-library-hero">
          <div className="landing-container guide-hero__inner">
            <p className="section-kicker">Paddiq resources</p>
            <h1>Your team’s operating guide.</h1>
            <p className="guide-hero__lead">
              Set up your workspace, bring in session data, and get more from every review.
              Practical guidance for drivers, coaches, and team managers.
            </p>
            <p className="guide-hero__meta">{RESOURCE_ARTICLES.length} resources</p>
          </div>
        </section>

        <section className="resource-library" aria-labelledby="resource-library-title">
          <div className="landing-container">
            <div className="resource-library__heading">
              <div>
                <p className="section-kicker">Browse the library</p>
                <h2 id="resource-library-title">Find the next step.</h2>
              </div>
              <a className="guide-text-link" href="/support">
                Need more help? Contact support
              </a>
            </div>

            <div className="resource-tools">
              <label className="resource-search">
                Search the guides
                <input
                  type="search"
                  value={query}
                  onChange={(event) => setQuery(event.target.value)}
                  placeholder="Paddiq Link, sessions, billing…"
                />
              </label>
              <div className="resource-filters" aria-label="Filter resources by category">
                {['All resources', ...RESOURCE_CATEGORIES].map((value) => (
                  <button
                    key={value}
                    type="button"
                    aria-pressed={category === value}
                    onClick={() => setCategory(value)}
                  >
                    {value}
                  </button>
                ))}
              </div>
            </div>
            <p className="resource-results" role="status">
              {articles.length} {articles.length === 1 ? 'guide' : 'guides'}
              {query ? ` matching “${query}”` : ''}
            </p>
            <div className="resource-library__grid">
              {articles.map((article, index) => (
                <a className="resource-card" href={article.path} key={article.path}>
                  <span className="resource-card__number" aria-hidden="true">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="resource-card__category">{article.category}</span>
                  <h3>{article.title}</h3>
                  <p>{article.description}</p>
                  <span className="resource-card__link">Read guide →</span>
                </a>
              ))}
            </div>
            {articles.length === 0 && (
              <div className="resource-empty">
                <h3>No matching guides.</h3>
                <p>Try a different search or browse the full library.</p>
                <button
                  className="landing-btn landing-btn--primary"
                  type="button"
                  onClick={() => {
                    setQuery('');
                    setCategory('All resources');
                  }}
                >
                  Clear filters
                </button>
              </div>
            )}
          </div>
        </section>
      </main>

      <MarketingFooter />
    </div>
  );
}
